export default __webpack_public_path__ + "static/media/Honored Greaves of the Seven Suns.f714108e.jpg";